import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BEST_OF_PANDORA_BROWSE_LINK } from '../../constants/MyStations';
import { AsyncDomain } from '../../domains';
import { getInDomain } from '../../domains/externalUtils';

class BrowseGenreBestOfPandora extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    getBrowseDirectory: PropTypes.func.isRequired,
    browseBestOfPandora: PropTypes.object,
  };

  componentDidMount() {
    if (!this.props.browseBestOfPandora) {
      this.props.getBrowseDirectory({
        path: BEST_OF_PANDORA_BROWSE_LINK,
        directoryFeedType: 'browse',
      });
    }
  }

  // In the case of a user removing a station, since we clear browse data after removal,
  // we need to call again in case user returns to empty state.
  componentDidUpdate(prevProps) {
    if (prevProps.browseBestOfPandora !== this.props.browseBestOfPandora) {
      this.props.getBrowseDirectory({
        path: BEST_OF_PANDORA_BROWSE_LINK,
        directoryFeedType: 'browse',
      });
    }
  }

  render() {
    const BrowseModuleComponent = (
      <AsyncDomain
        domain='discovery'
        key='BrowseModule'
        component='BrowseModule'
        section={this.props.browseBestOfPandora}
        maxItems={8}
      />
    );
    return (
      <div className='BrowseGenreBestOfPandora'>
        <div className='BrowseGenreBestOfPandora__gridContainer'>
          {this.props.browseBestOfPandora && BrowseModuleComponent}
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    browseBestOfPandora: getInDomain('discovery.selectors.getBrowseDeepLevelDirectoryByUrl')(
      state,
      BEST_OF_PANDORA_BROWSE_LINK,
    ),
  };
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getBrowseDirectory: getInDomain('discovery.actions.getBrowseDirectory'),
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BrowseGenreBestOfPandora));
